/** Da dove arriva una segnalazione: nome leggibile della pagina e, se c'è,
 *  la pratica aperta. Serve al triage per sapere dove guardare. */

// Dal più specifico al più generico: vince il primo prefisso che combacia.
const PAGINE: [string, string][] = [
  ["/agenzia/pratiche/", "Dettaglio pratica"],
  ["/agenzia/clienti/", "Dettaglio cliente"],
  ["/agenzia/bollette/", "Dettaglio bolletta"],
  ["/agenzia/dashboard", "Dashboard agenzia"],
  ["/agenzia/pratiche", "Pratiche"],
  ["/agenzia/clienti", "Clienti"],
  ["/agenzia/chat", "Consulenza"],
  ["/agenzia/profilo", "Profilo"],
  ["/affiliato/dashboard", "Le mie performance"],
  ["/affiliato/commissioni", "Commissioni"],
  ["/admin/listino", "Listino"],
  ["/admin/simulatore", "Simulatore"],
  ["/admin/commissioni", "Commissioni (amministrazione)"],
  ["/admin/reconcile", "Ricalcolo commissioni"],
  ["/admin/storni", "Storni"],
  ["/admin/invio-pratiche", "Invio pratiche"],
  ["/admin/utenze", "Utenze fornitore"],
  ["/admin/affiliazioni", "Affiliazioni"],
  ["/pratiche/", "Dettaglio pratica"],
  ["/bollette/", "Dettaglio bolletta"],
  ["/dashboard", "Dashboard"],
  ["/pratiche", "Pratiche"],
  ["/bollette", "Bollette"],
  ["/profilo", "Profilo"],
  ["/supporto", "Supporto live"],
  ["/news", "Novità"],
  ["/chat", "Consulenza"],
];

export function etichettaPagina(percorso: string): string {
  const trovata = PAGINE.find(([prefisso]) => percorso.startsWith(prefisso));
  return trovata ? trovata[1] : percorso;
}

/** Identificativo della pratica aperta, se il percorso è un dettaglio pratica. */
export function praticaDalPercorso(percorso: string): string | undefined {
  const m = percorso.match(/^\/(?:agenzia\/)?pratiche\/([^/]+)/);
  return m ? m[1] : undefined;
}
